/* ==========================================================================
   LITELOK — X1 vs X3 comparison page
   Shared behaviour for all x1x3-* sections.

   Mode (bike | moto) is stored on <html data-x1x3="...">. It is set
   synchronously by snippets/x1x3-mode-init.liquid before first paint, so
   there is no flash. Everything here is progressive enhancement: with JS
   off, the toggle degrades to real links and the page renders bike mode.
   ========================================================================== */
(function () {
  'use strict';

  // Every section renders the same <script> tag so it can be moved or removed
  // independently. The browser caches the file but still executes each tag —
  // this guard makes the extra executions a no-op.
  if (window.__x1x3Loaded) return;
  window.__x1x3Loaded = true;

  var MODES = ['bike', 'moto'];
  var PARAM = 'for';
  var STORE_KEY = 'x1x3-mode';
  var root = document.documentElement;

  /* ---------------------------------------------------------------- mode -- */

  function currentMode() {
    var m = root.getAttribute('data-x1x3');
    return MODES.indexOf(m) > -1 ? m : 'bike';
  }

  function setMode(mode, opts) {
    if (MODES.indexOf(mode) === -1 || mode === currentMode()) return;
    opts = opts || {};

    root.setAttribute('data-x1x3', mode);

    try {
      localStorage.setItem(STORE_KEY, mode);
    } catch (e) {
      /* private browsing — the URL still carries the choice */
    }

    // Keep the address bar shareable without adding a history entry.
    try {
      var url = new URL(window.location.href);
      url.searchParams.set(PARAM, mode);
      window.history.replaceState({}, '', url);
    } catch (e) {}

    syncToggles();
    track('x1x3_mode_change', { x1x3_mode: mode, x1x3_source: opts.source || 'toggle' });
    document.dispatchEvent(new CustomEvent('x1x3:mode', { detail: { mode: mode } }));
  }

  function syncToggles() {
    var mode = currentMode();
    document.querySelectorAll('[data-x1x3-toggle] [data-x1x3-set]').forEach(function (el) {
      el.setAttribute('aria-current', el.getAttribute('data-x1x3-set') === mode ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var opt = event.target.closest('[data-x1x3-set]');
    if (!opt) return;
    event.preventDefault();
    setMode(opt.getAttribute('data-x1x3-set'), { source: 'toggle' });
  });

  /* ----------------------------------------------------------- analytics -- */

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
    } catch (e) {}
  }

  /* ------------------------------------------------------------ scroll --- */

  function onScrollPast(target, cb) {
    if (!('IntersectionObserver' in window) || !target) return;
    new IntersectionObserver(
      function (entries) {
        cb(!entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      },
      { threshold: 0 }
    ).observe(target);
  }

  /* ------------------------------------------------------------- quiz ---- */

  function initQuiz(quiz) {
    if (quiz.dataset.x1x3Ready === 'true') return;
    quiz.dataset.x1x3Ready = 'true';

    var dataEl = quiz.querySelector('[data-x1x3-locks]');
    var locks = {};
    try {
      locks = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var body = quiz.querySelector('[data-quiz-body]');
    var resultEl = quiz.querySelector('[data-quiz-result]');
    var progress = quiz.querySelector('[data-quiz-progress]');
    var restart = quiz.querySelector('[data-quiz-restart]');
    var scores = {};
    var answered = 0;

    function questions() {
      // Only the questions for the active mode are in play.
      return Array.prototype.filter.call(quiz.querySelectorAll('[data-quiz-q]'), function (q) {
        return q.getAttribute('data-quiz-mode') === currentMode();
      });
    }

    function reset() {
      scores = {};
      answered = 0;
      resultEl.hidden = true;
      body.hidden = false;
      questions().forEach(function (q, i) {
        q.hidden = i !== 0;
        q.querySelectorAll('[data-score]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      });
      updateProgress();
    }

    function updateProgress() {
      if (!progress) return;
      var total = questions().length;
      progress.textContent =
        answered >= total ? 'Done' : 'Question ' + (answered + 1) + ' of ' + total;
    }

    function award(spec) {
      // spec looks like "x1:2,plus:1"
      spec.split(',').forEach(function (pair) {
        var bits = pair.split(':');
        var key = bits[0].trim();
        var value = parseFloat(bits[1]);
        if (!key || isNaN(value)) return;
        scores[key] = (scores[key] || 0) + value;
      });
    }

    function winner() {
      // Highest score wins; ties resolve to the more secure lock, using the
      // rank each lock is given in the section settings.
      var best = null;
      Object.keys(scores).forEach(function (key) {
        if (!locks[key]) return;
        if (
          !best ||
          scores[key] > scores[best] ||
          (scores[key] === scores[best] && (locks[key].rank || 0) > (locks[best].rank || 0))
        ) {
          best = key;
        }
      });
      return best;
    }

    function runnerUp(exclude) {
      var best = null;
      Object.keys(scores).forEach(function (key) {
        if (key === exclude || !locks[key]) return;
        if (!best || scores[key] > scores[best]) best = key;
      });
      return best;
    }

    function show(key, secondKey) {
      var lock = locks[key];
      if (!lock) return;
      var mode = currentMode();

      quiz.querySelectorAll('[data-result-name]').forEach(function (el) {
        el.textContent = lock.name;
      });
      var reason = quiz.querySelector('[data-result-reason]');
      if (reason) reason.textContent = lock[mode + '_reason'] || lock.bike_reason || '';

      var price = quiz.querySelector('[data-result-price]');
      if (price) price.innerHTML = lock[mode + '_price'] || lock.bike_price || '';

      var img = quiz.querySelector('[data-result-image]');
      if (img) {
        if (lock.image) {
          img.src = lock.image;
          img.alt = lock.name;
          img.hidden = false;
        } else {
          img.hidden = true;
        }
      }

      var cta = quiz.querySelector('[data-result-cta]');
      if (cta) cta.href = lock[mode + '_url'] || lock.bike_url || '#';

      var secondWrap = quiz.querySelector('[data-result-second]');
      if (secondWrap) {
        var second = secondKey ? locks[secondKey] : null;
        if (second) {
          secondWrap.hidden = false;
          secondWrap.querySelector('[data-second-name]').textContent = second.name;
          var secondNote = secondWrap.querySelector('[data-second-reason]');
          if (secondNote) secondNote.textContent = second[mode + '_short'] || '';
          var secondLink = secondWrap.querySelector('[data-second-link]');
          if (secondLink) secondLink.href = second[mode + '_url'] || second.bike_url || '#';
        } else {
          secondWrap.hidden = true;
        }
      }

      body.hidden = true;
      resultEl.hidden = false;
      updateProgress();

      document.dispatchEvent(
        new CustomEvent('x1x3:recommendation', { detail: { lock: key, mode: mode } })
      );
      track('x1x3_recommendation', { x1x3_lock: key, x1x3_mode: mode });
    }

    quiz.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-score]');
      if (!btn) return;

      var question = btn.closest('[data-quiz-q]');
      question.querySelectorAll('[data-score]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      award(btn.getAttribute('data-score'));
      answered += 1;

      var list = questions();
      var index = list.indexOf(question);
      question.hidden = true;

      if (index + 1 < list.length) {
        list[index + 1].hidden = false;
        updateProgress();
        list[index + 1].querySelector('[data-score]').focus();
      } else {
        var first = winner();
        show(first, runnerUp(first));
      }
    });

    if (restart) {
      restart.addEventListener('click', function () {
        reset();
        var firstBtn = quiz.querySelector('[data-quiz-q]:not([hidden]) [data-score]');
        if (firstBtn) firstBtn.focus();
        track('x1x3_recommender_restart', { x1x3_mode: currentMode() });
      });
    }

    // Switching mode swaps the question set, so start again.
    document.addEventListener('x1x3:mode', reset);

    reset();

    var started = false;
    quiz.addEventListener(
      'click',
      function () {
        if (started) return;
        started = true;
        track('x1x3_recommender_start', { x1x3_mode: currentMode() });
      },
      { once: true }
    );
  }

  /* ------------------------------------------------- spec table rows ---- */

  function initTable(wrap) {
    if (wrap.dataset.x1x3Ready === 'true') return;
    wrap.dataset.x1x3Ready = 'true';

    var table = wrap.querySelector('.x-table');
    var button = wrap.querySelector('[data-table-more]');
    if (!table || !button) return;

    var less = button.getAttribute('data-label-less');
    var more = button.getAttribute('data-label-more');

    button.addEventListener('click', function () {
      var open = table.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.firstElementChild.textContent = open ? less : more;
      if (open) track('x1x3_specs_expanded', { x1x3_mode: currentMode() });
    });
  }

  /* ------------------------------------------------------- sticky bar ---- */

  function initSticky(bar) {
    if (bar.dataset.x1x3Ready === 'true') return;
    bar.dataset.x1x3Ready = 'true';

    var triggerId = bar.getAttribute('data-trigger');
    var trigger = triggerId ? document.getElementById(triggerId) : null;
    if (!trigger) trigger = document.querySelector('[data-x1x3-sticky-trigger]');

    onScrollPast(trigger, function (past) {
      bar.classList.toggle('is-visible', past);
    });

    // When the recommender returns an answer, the bar follows it.
    document.addEventListener('x1x3:recommendation', function (event) {
      var quiz = document.querySelector('[data-x1x3-quiz]');
      if (!quiz) return;
      var dataEl = quiz.querySelector('[data-x1x3-locks]');
      if (!dataEl) return;
      var locks;
      try {
        locks = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      var lock = locks[event.detail.lock];
      if (!lock) return;
      var mode = event.detail.mode;

      var name = bar.querySelector('[data-sticky-name]');
      var price = bar.querySelector('[data-sticky-price]');
      var cta = bar.querySelector('[data-sticky-cta]');
      var intro = bar.querySelector('[data-sticky-intro]');

      if (intro) intro.textContent = intro.getAttribute('data-recommended-label') || 'Recommended for you';
      if (name) name.textContent = lock.name;
      if (price) price.innerHTML = lock[mode + '_price'] || lock.bike_price || '';
      if (cta) cta.href = lock[mode + '_url'] || lock.bike_url || '#';
    });
  }

  /* ------------------------------------------------------------- boot ---- */

  function boot(scope) {
    (scope || document).querySelectorAll('[data-x1x3-quiz]').forEach(initQuiz);
    (scope || document).querySelectorAll('[data-x1x3-table]').forEach(initTable);
    (scope || document).querySelectorAll('[data-x1x3-sticky]').forEach(initSticky);
    syncToggles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Shopify theme editor: re-initialise a section after it is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  window.X1X3 = { getMode: currentMode, setMode: setMode, track: track };
})();
